"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateKey = void 0;
var settings_key_format_1 = require("@wix/settings-key-format");
exports.generateKey = function (key, _a) {
    var isMobile = _a.isMobile;
    return settings_key_format_1.generateKey(key, { m: isMobile }, { m: false });
};
//# sourceMappingURL=generateKey.js.map